/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */
let tg = window.Telegram.WebApp;
tg.expand();
/* if (tg.platform=='android' || tg.platform=='ios') {
    tg.requestFullscreen();
    setInterval(() => {
        const appBar = document.querySelector('.v-app-bar');
        const main = document.querySelector('.v-application > .v-application__wrap > .v-main');
        if (appBar) {
          appBar.style.paddingTop = '50px';
          if (tg.platform=='android') main.style.setProperty('--v-layout-top', '124px');
          else main.style.setProperty('--v-layout-top', '184px');
        }
      }, 1000);    
} */
// Plugins
//import '@/loader.js';
import { registerPlugins } from '@/plugins'
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

const app = createApp(App)
app.use(Toast, {
    position: POSITION.TOP_CENTER, // Позиция отображения уведомлений
    timeout: 4000, // Время показа уведомления в миллисекундах
  });
app.component('VueDatePicker', VueDatePicker);
registerPlugins(app)

app.mount('#app')
console.log('import.meta.env.MODE', import.meta.env.MODE);
/* 
function makeRequest(data) {
  return new Promise(function(resolve, reject) {
    //if (import.meta.env.MODE=='development') return false;
    if (import.meta.env.DEV) return false;  
    var xhr = new XMLHttpRequest();
      var url = import.meta.env.VITE_BACKEND_URL + '/error';
      xhr.open('POST', url, true);
  
      xhr.setRequestHeader('Content-Type', 'application/json');
  
      xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
              if (xhr.status >= 200 && xhr.status < 300) {
                  // Success
                  resolve(true);
              } else {
                  // Error
                  resolve(false);
              }
          }
      };
  
      if (data) {
          xhr.send(JSON.stringify(data));
      } else {
          xhr.send();
      }
  });
}
function errorReport(data) {
  //return makeRequest(data);
}
let jsonData={};
window.onerror = function(message, source, lineno, colno, error) {
    
  // Логирование ошибки для разработчиков
  console.log('Error message:', message);
  console.log('Source:', source);
  console.log('Line number:', lineno);
  console.log('Column number:', colno);
  console.log('Error object:', error);

  jsonData={
      'user_id' : JSON.parse(localStorage.getItem('User')).id,
      'status_code': 0,
      'text': message,
      'method': source+' JSerror line:'+lineno
  };
  errorReport(jsonData).then(function(success) {
      if (success) {
          //alert('Возникла ошибка. Уведомление отправлено разработчикам. Попробуйте позже.');
      } else {
          //alert('Возникла ошибка. Сообщите подробности менеджеру, чтобы ошибку исправили.');
      }
  });
  return true;
};

window.addEventListener('unhandledrejection', function(event) {
  jsonData={
      'user_id' : JSON.parse(localStorage.getItem('User')).id,
      'status_code': 0,
      'text': event.reason.stack,
      'method': 'JSerror'
  };
  errorReport(jsonData).then(function(success) {
      if (success) {
          //alert('Возникла ошибка. Уведомление отправлено разработчикам. Попробуйте позже.');
      } else {
          //alert('Возникла ошибка. Сообщите подробности менеджеру, чтобы ошибку исправили.');
      }
  });
  // Логирование ошибки для разработчиков
  console.log('Unhandled rejection:', event);

  // Вернуть true, чтобы подавить сообщение об ошибке в консоли браузера
  return true;
}); */